import { render } from "./available-soon.svg?vue&type=template&id=fe11775c?inline"
const script = {}

import exportComponent from "C:\\Users\\diogo.correia\\Documents\\INM\\BAI\\hybrid-banking-v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__